import React from "react";

const Empty = ({ children }) => {
  return (
    <>
      <div style={{}}>{children}</div>
    </>
  );
};

export default Empty;
